import React from 'react';

const LoginBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden">
      {/* Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50 via-background to-secondary-50"></div>
      
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-full">
        {/* Top Left Circle */}
        <div className="absolute -top-24 -left-24 w-48 h-48 bg-primary-100 rounded-full opacity-60 blur-3xl"></div>
        
        {/* Top Right Circle */}
        <div className="absolute -top-12 -right-12 w-32 h-32 bg-secondary-100 rounded-full opacity-40 blur-2xl"></div>
        
        {/* Bottom Left Circle */}
        <div className="absolute -bottom-16 -left-16 w-40 h-40 bg-accent-100 rounded-full opacity-30 blur-2xl"></div>
        
        {/* Bottom Right Circle */}
        <div className="absolute -bottom-32 -right-32 w-56 h-56 bg-primary-100 rounded-full opacity-50 blur-3xl"></div>
      </div>

      {/* Grid Pattern Overlay */}
      <div className="absolute inset-0 opacity-5">
        <div className="w-full h-full" style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, rgba(59, 130, 246, 0.3) 1px, transparent 0)`,
          backgroundSize: '24px 24px'
        }}></div>
      </div>
    </div>
  );
};

export default LoginBackground;